<script setup lang="ts">
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion';

interface Props {
  heading: string;
  title: string;
  faqs: {
    heading: string;
    body: { html: string };
  }[];
}

const props = defineProps<Props>();
</script>

<template>
  <VSection>
    <v-container>
      <div class="flex flex-col gap-6 mx-auto justify-start">
        <h2 class="text-2xl lg:text-3xl font-bold text-gray-900">
          {{ heading ?? title }}
        </h2>
        <Accordion type="single" collapsible class="w-full">
          <AccordionItem
            v-for="(faq, index) in faqs"
            :key="`faq-${index}`"
            :value="`item-${index}`"
            class="border-b border-gray-200 last:border-b-0"
          >
            <AccordionTrigger class="text-lg lg:text-lg font-semibold focus:outline-none text-left">
              {{ faq.heading }}
            </AccordionTrigger>
            <AccordionContent>
              <div v-html="faq.body.html" class="prose text-gray-900 max-w-none" />
            </AccordionContent>
          </AccordionItem>
        </Accordion>
      </div>
    </v-container>
  </VSection>
</template>
